import React from "react";
import styled from "styled-components";

import Footer from "../components/Footer";
import Topbar from "../components/Topbar";

const Container = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const Content = styled.main`
  flex: 1;
`;

const TermsOfService = () => {
  return (
    <Container>
      <Topbar />
      <Content>
        <section className="legal-page">
          <div className="container legal-page-container">
            <div className="legal-page-header">
              <p className="section-label">Terms of Service</p>
              <h1>Application Terms of Service</h1>
              <p className="legal-updated">Last updated: 1 June 2026</p>
            </div>

            <div className="legal-page-content">
              <section>
                <h2>About These Terms</h2>
                <p>
                  These Terms of Service apply to your access to and use of the True-Extract website, upload portal, download portal, and related digital services. True-Extract is operated by DATA IN LTD, registered at 124 City Road, London, EC1V 2NX.
                </p>
                <p>
                  By using our application or services, you agree to these terms. If you are using the services on behalf of an organisation, you confirm that you have authority to accept these terms for that organisation.
                </p>
              </section>

              <section>
                <h2>Our Services</h2>
                <p>
                  True-Extract provides mobile forensics, digital evidence extraction, secure upload and download, analysis, reporting, and related support services. The exact scope, deliverables, timing, and fees for professional services may be set out in a separate written agreement, quote, statement of work, or client instruction.
                </p>
              </section>

              <section>
                <h2>Account And Access Security</h2>
                <p>
                  You are responsible for keeping any login details, access links, one-time PINs, and downloaded materials secure. You must not share access credentials with unauthorised people, bypass security controls, interfere with the application, or attempt to access data that has not been made available to you.
                </p>
                <p>
                  You must tell us promptly if you suspect unauthorised access, loss of credentials, or misuse of an upload or download link.
                </p>
              </section>

              <section>
                <h2>Your Responsibilities</h2>
                <p>You agree that you will:</p>
                <ul>
                  <li>provide accurate information when contacting us, submitting instructions, or uploading materials;</li>
                  <li>only upload, submit, or request access to materials that you are authorised to provide or receive;</li>
                  <li>comply with applicable laws, court orders, professional duties, and evidence handling requirements;</li>
                  <li>avoid uploading malicious files, unlawful content, or materials unrelated to the agreed service;</li>
                  <li>review any download, report, or deliverable promptly and notify us of any issue.</li>
                </ul>
              </section>

              <section>
                <h2>Case Materials And Evidence</h2>
                <p>
                  You remain responsible for the legality, accuracy, provenance, and completeness of materials you provide. Unless agreed otherwise in writing, we rely on the information and instructions you give us and do not independently verify your authority to submit or access case materials.
                </p>
                <p>
                  Forensic findings can depend on source device condition, available data, encryption, credentials, platform restrictions, and the quality of instructions received. We do not guarantee that every item of data can be recovered, extracted, analysed, or reported.
                </p>
              </section>

              <section>
                <h2>Acceptable Use</h2>
                <p>
                  You must not use the application or services for unlawful surveillance, unauthorised access, harassment, infringement of rights, distribution of malware, disruption of our systems, or any activity that could compromise data security, evidence integrity, or the rights of another person.
                </p>
              </section>

              <section>
                <h2>Fees And Payment</h2>
                <p>
                  Fees, expenses, taxes, payment dates, and any cancellation terms will be set out in the relevant quote, invoice, statement of work, or written agreement. Unless agreed otherwise, fees are payable in pounds sterling and may be due before delivery of final reports or downloads.
                </p>
              </section>

              <section>
                <h2>Intellectual Property</h2>
                <p>
                  We retain ownership of our application, website, software, workflows, templates, know-how, branding, and service methods. You retain ownership of materials you provide to us. Subject to payment and any agreed restrictions, you may use the reports and deliverables we provide for the purpose for which they were commissioned.
                </p>
              </section>

              <section>
                <h2>Confidentiality And Data Protection</h2>
                <p>
                  We treat client instructions and case materials as confidential, except where disclosure is required to deliver services, comply with law, protect our rights, or follow your authorised instructions. Our handling of personal data is described in our <a href="/privacy-policy">Privacy Policy</a>.
                </p>
              </section>

              <section>
                <h2>Availability And Changes</h2>
                <p>
                  We aim to keep the application available and secure, but we do not guarantee uninterrupted access. We may suspend, restrict, update, or withdraw parts of the application for maintenance, security, legal, or operational reasons.
                </p>
              </section>

              <section>
                <h2>Liability</h2>
                <p>
                  Nothing in these terms limits liability that cannot legally be limited, including liability for death or personal injury caused by negligence, fraud, or fraudulent misrepresentation. Subject to that, we are not liable for indirect loss, loss of profit, loss of business, loss of opportunity, or loss arising from inaccurate instructions, unauthorised materials, third-party systems, device limitations, or events outside our reasonable control.
                </p>
              </section>

              <section>
                <h2>Ending Access</h2>
                <p>
                  We may suspend or end your access to the application if you breach these terms, create a security or legal risk, fail to pay agreed fees, or if continued access could compromise our services, other users, or case materials.
                </p>
              </section>

              <section>
                <h2>Governing Law</h2>
                <p>
                  These terms are governed by the laws of England and Wales. The courts of England and Wales will have exclusive jurisdiction, unless a different jurisdiction is required by applicable law or agreed in writing.
                </p>
              </section>

              <section>
                <h2>Contact Us</h2>
                <p>
                  Questions about these terms can be sent to <a href="mailto:info@true-extract.co.uk">info@true-extract.co.uk</a>.
                </p>
              </section>
            </div>
          </div>
        </section>
      </Content>
      <Footer />
    </Container>
  );
};

export default TermsOfService;
